import { i18n } from "../translate/i18n";

export const CODIGOS_POR_CATEGORIA = {
  conta: [131042, 131031, 131045, 133010, 368, 130497, 134011, 190, 0, 3, 10, 131005, 131057, 2494100],
  contato: [131026, 131049, 131050, 130403, 131021],
  janela: [131047],
  template: [132000, 132001, 132005, 132007, 132012, 132015, 132016, 132018],
  limite: [130429, 131056, 4, 80007, 131048],
  midia: [131051, 131052, 131053],
};

// Espelha backend/src/helpers/ErroMeta.ts: so estes erros de conta marcam a conexao.
export const CODIGOS_QUE_MARCAM_CONEXAO = new Set([131042, 131031, 131045, 133010, 368, 130497, 134011, 190]);

// Codigos com texto proprio no i18n (metaErrors.<codigo>.title|action).
export const CODIGOS_COM_TEXTO = new Set([
  131042, 131031, 131045, 133010, 368, 130497, 134011, 190, 131047, 131026, 131050, 130403, 131049, 131021,
  132001, 132015, 132016,
]);

const CATEGORIA_POR_CODIGO = new Map();
Object.keys(CODIGOS_POR_CATEGORIA).forEach(cat => {
  CODIGOS_POR_CATEGORIA[cat].forEach(code => CATEGORIA_POR_CODIGO.set(code, cat));
});

export const classificaErroMeta = code => {
  if (code === null || code === undefined) return { categoria: "desconhecido", marcaConexao: false };
  const categoria = CATEGORIA_POR_CODIGO.get(Number(code)) || "desconhecido";
  return { categoria, marcaConexao: categoria === "conta" && CODIGOS_QUE_MARCAM_CONEXAO.has(Number(code)) };
};

export const extraiCodigoDoMotivo = texto => {
  if (!texto) return null;
  const m = String(texto).match(/\[(\d+)\]/);
  return m ? Number(m[1]) : null;
};

const REGEX_LINK_META = /https:\/\/business\.facebook\.com\/[^\s"'<>)]+/;

// Espelha extraiLinkMeta do backend.
export const extraiLinkMeta = texto => {
  if (!texto) return null;
  const m = String(texto).match(REGEX_LINK_META);
  return m ? m[0].replace(/[.,;]+$/, "") : null;
};

// So inteiros finitos (numero ou string numerica) valem como codigo; "" e booleanos nao.
const normalizaCodigo = v => {
  if (typeof v === "number") return Number.isInteger(v) ? v : null;
  if (typeof v === "string" && /^\d+$/.test(v.trim())) return Number(v.trim());
  return null;
};

// Resolve o idioma atual no momento da chamada.
export const descreveFalha = ({ failureCode, failureReason, failureLink } = {}) => {
  const original = failureReason ? String(failureReason) : null;
  let code = normalizaCodigo(failureCode);
  if (code === null) code = extraiCodigoDoMotivo(original);
  const { categoria, marcaConexao } = classificaErroMeta(code);
  const link = failureLink || extraiLinkMeta(original);

  // Sem codigo e sem texto (ex.: Baileys): frase generica, sem acao.
  if (code === null && !original) {
    return { code, categoria, marcaConexao, titulo: i18n.t("metaErrors.generic"), acao: "", link, original };
  }

  const base =
    code !== null && CODIGOS_COM_TEXTO.has(code)
      ? `metaErrors.${code}`
      : categoria === "desconhecido"
      ? "metaErrors.unknown"
      : `metaErrors.category.${categoria}`;
  return {
    code,
    categoria,
    marcaConexao,
    titulo: i18n.t(`${base}.title`),
    acao: i18n.t(`${base}.action`),
    link,
    original,
  };
};
